import React from 'react'
import css from './ListAdmin.module.scss'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { doSaveAdmin } from '../../../Services/Admin/AuthAdminSevices'
import { useNavigate } from 'react-router-dom'

const CreateUserAdminPage = () => {
    const navigate = useNavigate();
    const [isDeletedPopup, setisDeletedPopup] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const {control, register, handleSubmit, setValue, watch, formState: { errors }, reset} = useForm();
    const [buttonClicked, setButtonClicked] = useState('');

    const showModal = () => {
        setisDeletedPopup(true)
        setIsSuccess(true)
    };
    const hideModal = () => {
        reset();
        setisDeletedPopup(false)
        setIsSuccess(false)
    };

    const handleDeleteConfirm = () => {
        alert("Delete confirmed");
        hideModal();
    };
    
    function onCreate(data) {
        // alert('asd')
        if(buttonClicked == 'save'){
            doSaveAdmin(data).then((result) => {    
                setIsSuccess(true)
            }).catch(({ response }) => {
            });
        }else if(buttonClicked == 'delete'){
            showModal()
        }
    }
    
    return (
    <div className='wrap_admin'>
        {isDeletedPopup && 
            <div className={css.popup_wrap} onClick={hideModal}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={hideModal}></i>
                    <img src="/monitoring/assets/delete.png" />
                    <b>Delete Confirmation</b>
                    <p>You are about to delete this station, are you sure?</p>
                    <button onClick={hideModal} className='admin-button cancel'>No</button>
                    <button onClick={handleDeleteConfirm} className='admin-button delete'>Yes</button>
                </div> 
            </div>
        }
        
        {isSuccess && 
            <div className={css.popup_wrap} onClick={hideModal}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={hideModal}></i>
                    <img src="/monitoring/assets/success.png" />
                    <b>Successful!</b>
                    <p>The Data has just been created. </p>
                </div> 
            </div>
        }

        
        {isError && 
            <div className={css.popup_wrap} onClick={()=> setIsError(false)}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={()=> setIsError(false)}></i>
                    <img src="/monitoring/assets/error.png" />
                    <b>Error!</b>
                    <p>Station code already exists. </p>
                </div> 
            </div>
        }
        <div className='row vh-100'>
            <div className='col-md-12' style={{ maxHeight: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>
                <div className={`${css.content_position} row`} style={{ marginBottom: 100 }}>
                    <form className={`${css.form}`} onSubmit={handleSubmit(onCreate)}>
                        <label>Username</label>
                        <input type='text' placeholder='Add Username'     
                        {...register("username", { 
                            required: "This field is required",
                            pattern: {
                                value: /^[a-zA-Z0-9-_.@]+$/,
                                message: "Username must be alphanumeric and can only include -, ., @"
                            }
                        })}
                        />
                        {errors.username && <p style={{color:'red'}}>{errors.username.message}</p>}

                        <label>Email</label>
                        <input type='text' placeholder='Add Email' 
                            {...register("email", {
                                required: "Email is required",
                                pattern: {
                                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                  message: "Invalid email address"
                                }
                            })}
                        />
                        
                        <input type='hidden' value={'user'}
                            {...register("role")}  
                        />

                        {errors.email && <p style={{color:'red'}}>{errors.email.message}</p>}

                        <label>Password</label>
                        <input type='password' placeholder='Add Password'
                            {...register("password", { required: true })}
                        />
                        {errors.password && <p style={{color:'red'}}>This field is required</p>}

                        <label>Confirm Password</label>
                        <input type='password' placeholder='Confirm Password' 
                            {...register("confirm_password", { 
                                required: "This field is required",
                                validate: value =>
                                    value === watch("password") || "The passwords do not match"
                            })}
                        />
                        {errors.confirm_password && <p style={{color:'red'}}>{errors.confirm_password.message}</p>}
                        
                        <Controller
                            name="is_active"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                                <>
                                    <label>Status</label>
                                    <input
                                        type='radio'
                                        value={1}
                                        // checked={value == true ? true : true}
                                        onChange={() => onChange(true)}
                                    /> Active
                                    <input
                                        type='radio'
                                        value={0}
                                        // checked={value == false ? true : false}
                                        onChange={() => onChange(false)}
                                        style={{marginLeft:15}}
                                    /> Unactive
                                </>
                            )}
                        />
                        {errors.status && <p style={{color:'red'}}>This field is required</p>}

                        <div className='row' style={{marginTop:40, marginLeft:-15}}>
                            <div className='col-md-8'>
                                {/* <button className='admin-button delete' onClick={() => setButtonClicked('delete')}>Delete</button> */}
                            </div>
                            <div className='col-md-4' style={{float:'right'}}>
                                <button className='admin-button cancel' onClick={() => navigate(-1)} style={{marginRight:10}}>Cancel</button>
                                <button className='admin-button save' onClick={() => setButtonClicked('save')}>Save</button>  
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CreateUserAdminPage